module.exports = __webpack_public_path__ + "img/disaply_furniture.91877d2f.png";